<template>
  <div class="fb-cover-area">
    <div class="fb-cover">
      <div>
        <div class="fb-cover-bg">
          <header-carousel v-if="isCarousel" :base-data="baseData" />
          <div v-if="!baseData.images.header" class="placeholder-cover" />
        </div>

        <div class="fb-avatar">
          <div class="fb-container">
            <img v-if="!!baseData.images.logo" :src="baseData.images.logo" alt="" />
            <div v-if="$t('title_text') || baseData.headerText" class="fb-title-area">
              <h2
                :key="$i18n.locale"
                :style="titleTextStyles"
                v-text="replacePredefinedVariables($t('title_text'))"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import HeaderCarousel from './header-image/header.vue'
  import { replacePredefinedVariables } from '../../helpers'

  export default {
    components: {
      HeaderCarousel,
    },
    props: ['baseData'],
    computed: {
      isCarousel() {
        return Array.isArray(this.baseData.images.header)
      },
      titleTextStyles() {
        return {
          'font-size': `${this.baseData.sizes.titleTextSize} !important`,
          color: `${this.baseData.colors.textColor}`,
        }
      },
    },
    methods: {
      replacePredefinedVariables(text) {
        return replacePredefinedVariables(text)
      },
    },
  }
</script>

<style>
  .fb-cover-area .fb-avatar .fb-container {
    display: block;
  }

  .fb-cover-area .fb-avatar .fb-title-area {
    margin-left: 105px;
  }
</style>
